import type { FigmaRestApi, ZeytalTokens } from "@zeytal/types";

export const getStyleImplementationKeyRegExp = (
  styleType: FigmaRestApi.StyleType,
) => {
  if (styleType === "FILL") {
    return /^(stroke|fill)$/;
  } else if (styleType === "TEXT") {
    return /^text$/;
  } else if (styleType === "EFFECT") {
    return /^effect$/;
  } else if (styleType === "GRID") {
    return /^grid$/;
  }
  return / /;
};

export const findStyleValueKey = (mappedStyle: ZeytalTokens.MappedStyle) => {
  const { key, styleType, node } = mappedStyle;

  const styleImplementationKeyRegExp =
    getStyleImplementationKeyRegExp(styleType);

  const refType = Object.entries(node.styles).reduce((acc, [sType, sRef]) => {
    if (sRef === key && styleImplementationKeyRegExp.test(sType)) {
      acc = sType;
    }
    return acc;
  }, "");

  if (refType === "fill") {
    return "fills";
  } else if (refType === "stroke") {
    return "strokes";
  } else if (refType === "text") {
    return "style";
  } else if (refType === "effect") {
    return "effects";
  } else if (refType === "grid") {
    return "layoutGrids";
  }
};
